import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
import Swiper from "swiper";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
// ハンバーガーメニューをクリックでactiveを追加
const hamburgerMenuToggle = () => {
	document.querySelector(".hamburger").addEventListener("click", () => {
		document.querySelector(".hamburger").classList.toggle("is-active");
		document.querySelector(".nav-menu").classList.toggle("is-active");
		document.querySelector("html").classList.toggle("oh");
	});
};

// スムーススクロール
const smoothScroll = () => {
	$(".js-smooth").on("click", function (ev) {
		// goToSection.pause();
		let navHeight = $("header").innerHeight() * 1.25;
		// prevent default click event
		ev.preventDefault();
		// get the scroll-to target
		let targetSection = $(this).attr("href");
		// get vertical offset of target
		let targetOffset = $(targetSection).offset().top;
		gsap.to(window, {
			duration: 2,
			scrollTo: { y: targetOffset - navHeight },
			ease: "power4.out",
			onComplete: () => {},
		});
	});
};

const heroSlider = () => {
	const heroSwiper = new Swiper(".swiper-hero", {
		// modules: [Navigation, Pagination, Autoplay, EffectFade],
		loop: true,
		// loopedSlides: 3,
		// loopAdditionalSlides: 1.25,
		speed: 1000,
		slidesPerView: 1.25,
		centeredSlides: true,
		spaceBetween: 5,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		// breakpoints: {
		// 	640: {
		// 		slidesPerView: 1.25,
		// 		centeredSlides: false,
		// 		spaceBetween: 20,
		// 	},
		// 	1024: {
		// 		slidesPerView: 1.25,
		// 		centeredSlides: center,
		// 		spaceBetween: 20,
		// 	},
		// },
		// effect: "fade",
		// fadeEffect: {
		// 	crossFade: true,
		// },
		// pagination: {
		// 	el: ".swiper-pagination",
		// },
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		on: {
			init: function () {
				this.autoplay.stop();
				this.autoplay.start();
			},
		},
	});
};

//TOPページでのheaderのfixed
const headerFixed = () => {
	ScrollTrigger.create({
		trigger: "#headerFixed",
		start: "top top",
		endTrigger: "footer",
		end: "bottom bottom",
		// markers: true,
		toggleClass: { targets: "#positionHeader", className: "fixed-header" },
	});
};

const displayScrollTop = () => {
	const scroll_to_top_btn = document.querySelector("#scroll-to-top-btn");
	window.addEventListener("scroll", scroll_event);

	function scroll_event() {
		if (window.pageYOffset > 400) {
			scroll_to_top_btn.style.opacity = "1";
		} else if (window.pageYOffset < 400) {
			scroll_to_top_btn.style.opacity = "0";
		}
	}
};

const tabChangeContent = () => {
	document.querySelectorAll(".tab").forEach((tab) => {
		tab.addEventListener("click", () => {
			const activeContent = document.querySelector(
				".tab-content .tab-content-in.active"
			);
			if (activeContent) {
				activeContent.addEventListener(
					"transitionend",
					function callback() {
						activeContent.classList.remove("active");
						activeContent.style.display = "none";
						activeContent.removeEventListener(
							"transitionend",
							callback
						);
					}
				);
				activeContent.style.opacity = "0";
			}
			document.querySelectorAll(".tab").forEach((item) => {
				item.classList.remove("active");
			});
			tab.classList.add("active");
			const content = document.getElementById(
				"content" + tab.id.replace("tab", "")
			);
			content.style.display = "block";
			setTimeout(() => {
				content.style.opacity = "1";
				// 高さを取得して.tab-contentに適用
				const height = content.offsetHeight;
				document.querySelector(
					".tab-content"
				).style.height = `${height}px`;
			}, 500);
			content.classList.add("active");
		});
	});
};

window.addEventListener("load", () => {});

window.addEventListener("DOMContentLoaded", () => {
	// smoothScroll();
	// hamburgerMenuToggle();
	headerFixed();
	// displayScrollTop();
	heroSlider();
	const initialContent = document.querySelector(".tab-content #content1");
	if (initialContent) {
		const initialHeight = initialContent.offsetHeight;
		document.querySelector(
			".tab-content"
		).style.height = `${initialHeight}px`;
	}
	tabChangeContent();
});
